import { useAppUI } from "providers/ui"
import { MobileNavigation } from "../components/Navigation/MobileNavigation"

export const AppNavigation = () => {
  const { sideMenus, mainMenus, matchedPath } = useAppUI()

  return (
    <MobileNavigation
      value={matchedPath?.to}
      bottomNavigations={mainMenus}
      navigations={sideMenus}
    />
  )
}
